module.exports = __webpack_public_path__ + "img/gth_gbt2089_1994_left.prt.c1647b32.jpg";